import React from 'react';
import { ChevronLeft, ChevronRight } from 'react-feather';
import Icon from '../../Icon';
var StoreCheckoutModalPagination = props => {
  var {
    setCurrentPage,
    currentGroupPage,
    setCurrentGroupPage,
    paginationStores,
    classes,
    currentPage
  } = props;
  if (paginationStores.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.paginationContainer
  }, currentGroupPage !== 0 ? /*#__PURE__*/React.createElement("button", {
    disabled: currentGroupPage === 0,
    className: classes.paginationButtons,
    onClick: () => {
      setCurrentGroupPage(currentGroupPage - 1);
      setCurrentPage(0);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 20,
    src: ChevronLeft
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.paginationButtons,
    style: {
      visibility: 'hidden'
    }
  }), paginationStores[currentGroupPage].length > 0 ? paginationStores[currentGroupPage].map((c, index) => /*#__PURE__*/React.createElement("button", {
    className: classes.paginationButtons,
    style: index === currentPage ? {
      backgroundColor: 'black',
      color: 'white'
    } : {},
    onClick: () => {
      setCurrentPage(index);
    }
  }, currentGroupPage * 3 + index + 1)) : null, currentGroupPage < paginationStores[currentGroupPage].length && paginationStores.length > 1 && currentGroupPage < paginationStores.length - 1 ? /*#__PURE__*/React.createElement("button", {
    className: classes.paginationButtons,
    onClick: () => {
      setCurrentGroupPage(currentGroupPage + 1);
      setCurrentPage(0);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 20,
    src: ChevronRight
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.paginationButtons,
    style: {
      visibility: 'hidden'
    }
  }));
};
export default StoreCheckoutModalPagination;